import React from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import Select from "react-select";
import { taskPriorityOptions } from "../../utils/constant";

const AssignedTaskFilter = ({
    projectOptions,
    departmentOptions,
    subDeptOptions,
    assignByOptions,
    idcOptions,
    project,
    setProject,
    department,
    setDepartment,
    subDepartment,
    setSubDepartment,
    assignby,
    setAssignBY,
    taskpriority,
    setTaskpriority,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    idcMin,
    setIdcMin,
    idcMax,
    setIdcMax,
    qwdMin,
    setQwdMin,
    qwdMax,
    setQwdMax,
    onSubmit,
    onClear,
    taskStatus
}) => {

    const selectStyle = {
        menuPortalTarget: document.body,
        styles: {
            menuPortal: (base) => ({ ...base, zIndex: 9999 })
        }
    };

    return (
        <Row className="mb-3 p-3 rounded bg-light">

            {/* FIRST ROW */}
            <Col md={4}>
                <Form.Label>Project</Form.Label>
                <Select options={projectOptions} value={project} onChange={setProject} {...selectStyle} />
            </Col>

            <Col md={4}>
                <Form.Label>Department</Form.Label>
                <Select options={departmentOptions} value={department} onChange={setDepartment} {...selectStyle} />
            </Col>

            <Col md={4}>
                <Form.Label>Sub Department</Form.Label>
                <Select options={subDeptOptions} value={subDepartment} onChange={setSubDepartment} isDisabled={!department} {...selectStyle} />
            </Col>

            <Col md={3}>
                <Form.Label>Task Priority</Form.Label>
                <Select options={taskPriorityOptions} value={taskpriority} onChange={setTaskpriority} {...selectStyle} />
            </Col>

            {/* SECOND ROW */}
            <Col md={3}>
                <Form.Label>Assign By</Form.Label>
                <Select options={assignByOptions} value={assignby} onChange={setAssignBY} {...selectStyle} />
            </Col>

            <Col md={3}>
                <Form.Label>Start Date</Form.Label>
                <Form.Control
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                />
            </Col>

            <Col md={3}>
                <Form.Label>End Date</Form.Label>
                <Form.Control
                    type="date"
                    value={endDate}
                    min={startDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    disabled={!startDate}
                />
            </Col>

            {/* IDC + QWD only for completed */}
            {taskStatus === "completed" && (
                <>
                    <Col md={3}>
                        <Form.Label>Min IDC</Form.Label>
                        <Select options={idcOptions} value={idcMin} onChange={setIdcMin} {...selectStyle} />
                    </Col>

                    <Col md={3}>
                        <Form.Label>Max IDC</Form.Label>
                        <Select options={idcOptions} value={idcMax} onChange={setIdcMax} {...selectStyle} />
                    </Col>

                    <Col md={3}>
                        <Form.Label>Min QWD</Form.Label>
                        <Select options={idcOptions} value={qwdMin} onChange={setQwdMin} {...selectStyle} />
                    </Col>

                    <Col md={3}>
                        <Form.Label>Max QWD</Form.Label>
                        <Select options={idcOptions} value={qwdMax} onChange={setQwdMax} {...selectStyle} />
                    </Col>
                </>
            )}

            <Col md={12} className="d-flex justify-content-end gap-3 mt-3">
                <Button className="primaryBtn px-4" onClick={onSubmit}>
                    Submit
                </Button>
                <Button className="clearBtn px-4" onClick={onClear}>
                    Clear
                </Button>
            </Col>
        </Row>
    );
};

export default AssignedTaskFilter;